<div class="header">
  <h2>{{ "pages.dozent.exercises.title" | translate }}</h2>
  <div class="header-actions">
    <app-dozent-filter-dropdown (changed)="loadExercises()"></app-dozent-filter-dropdown>
    <button
      nbButton
      status="primary"
      appearance="outline"
      (click)="openTestExerciseDialog()"
    >
      <nb-icon icon="paper-plane-outline"></nb-icon>
      {{ "pages.dozent.exercises.testExercise" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      alAnchor="dozent.exercise-create"
      [nbPopover]="createMenu"
      nbPopoverClass="create-menu-popover"
      nbPopoverPlacement="bottom"
    >
      <nb-icon icon="plus"></nb-icon>
      {{ "pages.dozent.exercises.create" | translate }}
    </button>
  </div>
</div>

<ng-template #createMenu>
  <div
    class="create-menu"
    role="menu"
    [attr.aria-label]="'pages.dozent.exercises.create' | translate"
  >
    <div class="create-menu-header">
      <span>{{ "pages.dozent.exercises.create" | translate }}</span>
    </div>
    <div class="create-menu-list">
      <button
        type="button"
        class="create-menu-item"
        role="menuitem"
        alAnchor="dozent.exercise-scratch"
        (click)="openCreateDialog('scratch')"
      >
        <span class="create-menu-icon">
          <nb-icon icon="edit-outline"></nb-icon>
        </span>
        <span class="create-menu-copy">
          <span class="create-menu-title">
            {{ "pages.dozent.exercises.fromScratch" | translate }}
          </span>
        </span>
      </button>
      <button
        type="button"
        class="create-menu-item"
        role="menuitem"
        alAnchor="dozent.exercise-from-kb"
        (click)="openCreateDialog('kb')"
      >
        <span class="create-menu-icon">
          <nb-icon icon="book-open-outline"></nb-icon>
        </span>
        <span class="create-menu-copy">
          <span class="create-menu-title">
            {{ "pages.dozent.exercises.fromKnowledgeBase" | translate }}
          </span>
        </span>
      </button>
      <button
        type="button"
        class="create-menu-item"
        role="menuitem"
        (click)="openImportDialog()"
      >
        <span class="create-menu-icon">
          <nb-icon icon="cloud-upload-outline"></nb-icon>
        </span>
        <span class="create-menu-copy">
          <span class="create-menu-title">
            {{ "pages.dozent.exercises.fromDocument" | translate }}
          </span>
        </span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Search -->
<div class="search" *ngIf="exercises.length > 0">
  <div class="search-field-wrapper">
    <nb-form-field>
      <input
        type="text"
        nbInput
        fullWidth
        placeholder="{{ 'pages.dozent.exercises.searchPlaceholder' | translate }}"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
      />
      <button nbSuffix nbButton ghost>
        @if (searchText && searchText.length > 0) {
        <nb-icon
          icon="close-outline"
          (click)="searchText = ''; onSearchChange()"
        ></nb-icon>
        } @else {
        <nb-icon icon="search-outline" pack="eva"></nb-icon>
        }
      </button>
    </nb-form-field>
  </div>

  <div class="actions-right">
    <nb-button-group (valueChange)="onCardSizeSelect($event)">
      <button
        [pressed]="cardSize === 'small'"
        nbButtonToggle
        value="small"
        [title]="'pages.dozent.exercises.smallCards' | translate"
      >
        <svg viewBox="0 0 18 18" width="16" height="16" fill="currentColor">
          <rect x="0" y="0" width="5" height="5" rx="0.5"/>
          <rect x="6.5" y="0" width="5" height="5" rx="0.5"/>
          <rect x="13" y="0" width="5" height="5" rx="0.5"/>
          <rect x="0" y="6.5" width="5" height="5" rx="0.5"/>
          <rect x="6.5" y="6.5" width="5" height="5" rx="0.5"/>
          <rect x="13" y="6.5" width="5" height="5" rx="0.5"/>
          <rect x="0" y="13" width="5" height="5" rx="0.5"/>
          <rect x="6.5" y="13" width="5" height="5" rx="0.5"/>
          <rect x="13" y="13" width="5" height="5" rx="0.5"/>
        </svg>
      </button>
      <button
        [pressed]="cardSize === 'large'"
        nbButtonToggle
        value="large"
        [title]="'pages.dozent.exercises.largeCards' | translate"
      >
        <svg viewBox="0 0 18 18" width="16" height="16" fill="currentColor">
          <rect x="0" y="0" width="8" height="8" rx="0.5"/>
          <rect x="10" y="0" width="8" height="8" rx="0.5"/>
          <rect x="0" y="10" width="8" height="8" rx="0.5"/>
          <rect x="10" y="10" width="8" height="8" rx="0.5"/>
        </svg>
      </button>
    </nb-button-group>
  </div>
</div>

<!-- Exercise Grid -->
<app-page-loader *ngIf="isLoading"></app-page-loader>

<nb-card *ngIf="!isLoading && loadFailed" class="empty-state">
  <nb-card-body>
    <nb-icon icon="alert-triangle-outline" class="empty-icon"></nb-icon>
    <p>{{ "pages.dozent.exercises.loadErrorHint" | translate }}</p>
    <button nbButton status="basic" (click)="loadExercises()">
      <nb-icon icon="refresh-outline"></nb-icon>
      {{ "pages.dozent.exercises.retry" | translate }}
    </button>
  </nb-card-body>
</nb-card>

<nb-card
  *ngIf="!isLoading && !loadFailed && filteredExercises.length === 0"
  class="empty-state"
>
  <nb-card-body>
    <nb-icon icon="file-text-outline" class="empty-icon"></nb-icon>
    <p>{{ "pages.dozent.exercises.empty" | translate }}</p>
    <button nbButton status="primary" (click)="openCreateDialog('scratch')">
      <nb-icon icon="plus"></nb-icon>
      {{ "pages.dozent.exercises.create" | translate }}
    </button>
  </nb-card-body>
</nb-card>

<div class="card-grid {{ cardSize }}" *ngIf="!isLoading && !loadFailed && filteredExercises.length > 0">
  <!-- CI-Kachel: Material aus `al-glass al-glass--tile` (styles.scss
       „Kacheln", Tokens aus design/portal-ci/), Inhalt in `.al-glass__body`
       über dem Lichtsaum. Die Aktionsleiste liegt bewusst AUSSERHALB davon. -->
  <div
    *ngFor="let exercise of pagedExercises"
    class="exercise-card al-glass al-glass--tile"
    (click)="onEditExercise(exercise)"
  >
    <div class="card-content al-glass__body">
    <div class="card-banner">
      <span
        class="status-dot"
        [class.published]="exercise.is_published"
      ></span>
      <span class="status-label">
        {{
          exercise.is_published
            ? ("pages.dozent.exercises.published" | translate)
            : ("pages.dozent.exercises.draft" | translate)
        }}
      </span>
      <span
        class="chat-practice-badge"
        *ngIf="exercise.chat_practice_enabled"
        [nbTooltip]="'pages.dozent.exercises.chatPracticeHint' | translate"
      >
        <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2 4 5v6c0 5 3.4 9.5 8 11 4.6-1.5 8-6 8-11V5l-8-3zm-1.4 14.2L7 12.6l1.4-1.4 2.2 2.2 5-5 1.4 1.4-6.4 6.4z"
          />
        </svg>
        {{ "pages.dozent.exercises.chatPracticeBadge" | translate }}
      </span>
      <span class="new-import-badge" *ngIf="isNewImport(exercise)">
        {{ "pages.dozent.exercises.newBadge" | translate }}
      </span>
      <span
        class="creator-badge"
        *ngIf="exercise.creator_item_id"
        [nbTooltip]="'pages.dozent.exercises.creatorHint' | translate"
      >
        {{ "pages.dozent.exercises.creatorBadge" | translate: { version: exercise.creator_version_no } }}
      </span>
    </div>

    <div class="card-body">
      <h6 class="card-title">{{ exercise.title }}</h6>
      <p class="card-description" *ngIf="exercise.description">
        {{ exercise.description }}
      </p>

      <div class="card-details">
        <div class="detail-row">
          <nb-icon icon="layers-outline"></nb-icon>
          <span class="detail-label">{{ "pages.dozent.exercises.type" | translate }}</span>
          <span class="detail-value">{{ getExerciseTypeLabel(exercise.exercise_type) }}</span>
        </div>
        <div class="detail-row">
          <nb-icon icon="file-text-outline"></nb-icon>
          <span class="detail-label">{{ "pages.dozent.exercises.questions" | translate }}</span>
          <span class="detail-value">{{ getQuestionCount(exercise) }}</span>
        </div>
        <div class="detail-row">
          <nb-icon icon="award-outline"></nb-icon>
          <span class="detail-label">{{ "pages.dozent.exercises.points" | translate }}</span>
          <span class="detail-value">{{ exercise.max_score }}</span>
        </div>
        <div class="detail-row">
          <nb-icon icon="clock-outline"></nb-icon>
          <span class="detail-label">{{ "pages.dozent.exercises.createdAt" | translate }}</span>
          <span class="detail-value">{{ exercise.created_at | date: "dd.MM.yy" }}</span>
        </div>
      </div>
    </div>
    </div>

    <div class="card-overlay">
      <div
        class="overlay-btn"
        (click)="onPencil(exercise); $event.stopPropagation()"
        [nbTooltip]="'pages.dozent.exercises.editInCreator' | translate"
        [nbTooltipDisabled]="!exercise.creator_item_id"
      >
        <nb-icon status="primary" icon="edit-outline"></nb-icon>
      </div>
      <div
        class="overlay-btn"
        (click)="onTogglePublish(exercise); $event.stopPropagation()"
      >
        <nb-icon
          [status]="exercise.is_published ? 'warning' : 'success'"
          [icon]="exercise.is_published ? 'eye-off-outline' : 'eye-outline'"
        ></nb-icon>
      </div>
      <div
        class="overlay-btn"
        (click)="onToggleChatPractice(exercise); $event.stopPropagation()"
        [nbTooltip]="
          (exercise.chat_practice_enabled
            ? 'pages.dozent.exercises.chatPracticeDisable'
            : 'pages.dozent.exercises.chatPracticeEnable'
          ) | translate
        "
      >
        <nb-icon
          [status]="exercise.chat_practice_enabled ? 'warning' : 'success'"
          [icon]="exercise.chat_practice_enabled ? 'shield-off-outline' : 'shield-outline'"
        ></nb-icon>
      </div>
      <div class="overlay-btn" (click)="onDeleteExercise(exercise); $event.stopPropagation()">
        <nb-icon status="danger" icon="trash-outline"></nb-icon>
      </div>
    </div>
  </div>
</div>

<app-pagination
  *ngIf="!isLoading && filteredExercises.length > 0"
  class="exercise-pagination"
  [totalItems]="filteredExercises.length"
  [itemsPerPage]="exercisePageSize"
  [currentPage]="exercisePage"
  [pageSizeOptions]="exercisePageSizeOptions"
  (pageChanged)="onExercisePageChange($event)"
  (itemsPerPageChange)="onExercisePageSizeChange($event)"
></app-pagination>
